import "./FormikCheckboxComponent.scss";
import {useCallback} from "react";
import {FieldProps} from "formik";
import _ from "lodash";
import CheckBoxComponent from "../checkbox/CheckboxComponent";

export interface FormikCheckboxComponentProps {
    formikField: FieldProps;
    id?: string;
    label?: any;
    disableRipple?: boolean;
    size?: "medium" | "small" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    onUpdate?: Function;
    required?: boolean;
    disabled?: boolean;

}

const FormikCheckboxComponent = (props: FormikCheckboxComponentProps) => {

    const {formikField,disableRipple, id, label, disabled, onUpdate, required} = props;
    let {color, size} = props;
    const {field, form} = formikField;
    const {name, value} = field;
    const {setFieldTouched, touched, errors, setFieldValue} = form;
    const hasError = _.get(touched, name) && !!(_.get(errors, name));

    const onValueChange = useCallback((isCheckbox: boolean) => {
        setFieldValue(name, isCheckbox);
        setFieldTouched(name);
        if (onUpdate) {
            onUpdate(isCheckbox);
        }
    }, [setFieldValue, setFieldTouched, name, onUpdate]);

    return (
        <div className={'formik-checkbox-component component'}>
            <CheckBoxComponent
                color={color}
                size={size}
                name={name}
                checked={value}
                label={label}
                id={id}
                disableRipple={disableRipple}
                required={required}
                disabled={disabled}
                value={value}
                onUpdate={onValueChange}
                hasError={hasError}
                errorMessage={hasError && _.get(errors, name)}
            />
        </div>
    );

};

export default FormikCheckboxComponent;